import { useContext, useMemo } from "react";
import { ThemeContext } from "../contexts/ThemeContext";
import { themeConfig } from "../styles/themeConfig";

export const useTheme = () => {
  const { isDark, setTheme } = useContext(ThemeContext);

  const colors = useMemo(() => {
    const theme = isDark ? "dark" : "light";
    return themeConfig[theme];
  }, [isDark]);

  const getColor = (colorKey) => {
    return colors[colorKey];
  };

  return { isDark, setTheme, getColor, colors };
};
